import { IRequestOptions, IResponseResult } from 'models/api.model'
import { APP_NAME, RequestMethod, SubscriptionListType } from 'root-constants'
import { ApiService } from 'services/api.service'
import { IRawSubscription } from 'models/subscriptions.model'

export class SubscriptionsApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getSubscriptionList({
    cohort,
    type,
  }: {
    cohort: string
    type: SubscriptionListType
  }): Promise<IResponseResult<{ prices: IRawSubscription[] }>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { type },
    }

    return this.api.makeRequest<{ prices: IRawSubscription[] }>(
      `v1/flow/${APP_NAME}/variant/${cohort}/prices`,
      options,
    )
  }
}
